import { Tooltip, Stack } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J2Caution } from '@e3dc-react/icons'
import { useTheme } from '@mui/material/styles'

/**
 * This component shows a 'caution' icon with a tooltip.
 */
const NoInstallationIdTooltip: React.FC = () => {
  const { t } = useCustomTranslation()
  const theme = useTheme()

  return (
    <Tooltip title={t('errors.emsMasterDeviceIdMissing')}>
      <Stack component="span">
        <J2Caution style={{ width: theme.spacing(4), height: theme.spacing(4) }} />
      </Stack>
    </Tooltip>
  )
}

export default NoInstallationIdTooltip
